import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { GET_MATERIAL } from "./type";

export const getMaterialDelivery = (id) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.installation.getMaterialDelivery}?site_id=${id}`
  );
  if (res) {
    const { data } = res;
    dispatch({
      type: GET_MATERIAL,
      payload: data.response.data,
    });
    return true;
  }
};

export const postMaterialDelivery = (data) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    data,
    `${Config.installation.postMaterialDelivery}`
  );
  if (res?.data?.response?.status) {
    return res?.data?.response?.status;
  } else return false;
};

export const updateStatus = (siteId, stageId,isCP=0) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    "",
    `${Config.installation.statusUpdate}?site_id=${siteId}&stage_id=${stageId}&isCP=${isCP}`
  );
  if (res?.data?.response?.status) {
    return true;
  } else return false;
};
